
import React from 'react';

const EmptyPortfolioContent: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-10 px-4 bg-gray-50 rounded-lg border border-dashed border-gray-200">
      <div className="text-center max-w-md">
        <h3 className="text-lg font-medium text-gray-700 mb-2">No businesses yet</h3>
        <p className="text-gray-500 mb-6">Add your first business to get started with managing your portfolio.</p>
      </div>
    </div>
  );
};

export default EmptyPortfolioContent;
